window.app_models.company = {
    id:null,
    name: null,
    email:null,
    office:null,
    office_ext:null,
    fax:null,
    approved: null,
    address:window.app_models.address,
    company_contacts: [window.app_models.company_contact],
    company_type_id: null,
    housing_fee_type_id: null,
    pays_directly: null,
    pays_electronically: null,
    negotiated_fees: null,
    guidelines: null,
    pivot:{
        "start_date":null,
        "end_date":null,
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/company.js